export default {"src":"/_next/static/image/public/images/ic_account_circle_white.89df360c3596529b441e06e0a3201d01.svg","height":16,"width":16};